/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseBankAccountRibDto } from '../../models/api-response-bank-account-rib-dto';
import { BankAccountRibDto } from '../../models/bank-account-rib-dto';

export interface AddBankAccount$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  methodReference: string;
      body: BankAccountRibDto
}

export function addBankAccount(http: HttpClient, rootUrl: string, params: AddBankAccount$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseBankAccountRibDto>> {
  const rb = new RequestBuilder(rootUrl, addBankAccount.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('methodReference', params.methodReference, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseBankAccountRibDto>;
    })
  );
}

addBankAccount.PATH = '/v1/api/payment-methods/{methodReference}/bank-accounts';
